import React from 'react'
import { FeaturedInfo } from '../components/featured/FeaturedInfo'
import { FeaturedCards } from '../components/featured/FeaturedCards'

export function Featured() {
  return (
    <div>
      <FeaturedInfo />
      <FeaturedCards />
    </div>
  )
}
